

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop, Watch} from "vue-property-decorator";
import {namespace} from "vuex-class";
import {IServiceProvider} from "@/model/Service/serviceProviderInterfaces";
import {IErrors} from "@/model/IErrors";
import {ICity} from "@/store/modules/serviceProviderModule";

const serviceProviderModule = namespace("serviceProviderModule");

@Component({})
export default class SPScope extends Vue {

  @Prop()
  protected provider!: IServiceProvider;
  @Prop()
  protected errors!: IErrors;
  @Prop()
  protected editing!: boolean;
  @Prop()
  protected viewing!: boolean;
  @Prop()
  protected disabled!: boolean;

  @serviceProviderModule.Getter('cities')
  private cities!: ICity[];

  @serviceProviderModule.Action('fetchCities')
  private fetchCities!: () => any;

  private readonly VERTICAL_IDS: number[] = [10, 20, 30, 40, 50, 60];

  private readonly ZIPCODE_REGEXES: {[key: number]: RegExp} = {
    724: /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/,             // Spain
    826: /^[A-Z]{1,2}[0-9][0-9A-Z]?\s*[0-9][A-Z]{2}$/i,  // UK
    620: /^\d{4}-\d{3}$/,                                  // Portugal
    276: /^\d{5}$/,                                        // Germany
    208: /^\d{4}$/,                                        // Denmark
    528: /^\d{4}\s*[A-Z]{2}$/i,                            // Netherlands
  };

  public submitted: boolean = false;

  created() {
    this.fetchCities();
  }

  public markSubmitted() {
    this.submitted = true;
  }

  public get isValid(): boolean {
    return !!this.provider.scope_country_id && !this.zipcodeErrors;
  }

  protected get countryErrors(): string[] {
    if (this.submitted && !this.provider.scope_country_id) {
      return [this.$t('services.provider.scope.countryRequired').toString()];
    }
    return [];
  }

  protected get availableCities(): ICity[] {
    const countryId = Number(this.provider.scope_country_id);
    if (!countryId) {
      return [];
    }
    return this.cities.filter(function(city) {
      return city.country_id === countryId;
    });
  }

  protected get verticalItems(): { text: string; value: number }[] {
    return this.VERTICAL_IDS.map((id) => ({
      text: this.$t('lockers.locker.fields.vertical.values.' + id).toString(),
      value: id,
    }));
  }

  protected get zipcodeErrors(): string {
    const zipcodes = this.provider.zipcodes || [];
    if (!zipcodes.length) {
      return '';
    }
    const countryId = Number(this.provider.scope_country_id);
    if (!countryId) {
      return this.$t('services.provider.scope.selectCountryFirst').toString();
    }
    const regex = this.ZIPCODE_REGEXES[countryId];
    if (!regex) {
      return '';
    }
    const invalid = zipcodes.filter(function(z) {
      return !regex.test((z || '').trim());
    });
    if (!invalid.length) {
      return '';
    }
    return this.$t('services.provider.scope.invalidZipcode').toString() + ': ' + invalid.join(', ');
  }

  @Watch('provider.scope_country_id')
  protected onCountryChanged() {
    if (this.editing) {
      Vue.set(this.provider, 'city_ids', []);
      Vue.set(this.provider, 'zipcodes', []);
    }
  }

  @Watch('editing')
  protected onEditingChanged(editing: boolean) {
    if (!editing) {
      this.submitted = false;
    }
  }
}
